import React, {memo, useState} from "react";
import {Table, Pagination, Button} from "react-bootstrap";
import Swal from "sweetalert2";
import axios from 'axios';
import moment from "moment";

function DataTable({response, setPage, change, setChange, deleteItem}) {
    const [show, setShow] = useState(false);
    const [userData, setUserData] = useState();


    return (
        <>
            <div className="bg-white rounded border mb-3">
                <Table hover responsive className="mb-0">
                    <thead>
                    <tr>
                        <th>Ödeme No</th>
                        <th>Editör</th>
                        <th>Ödeme Tarihi</th>
                        <th>Ödeme Tutarı</th>
                        <th>Ödeme Yapan Yetkili</th>
                    </tr>
                    </thead>
                    <tbody>

                    {response.data && (response.data).map((element) => (
                        <tr key={element.paymentId}>
                            <td>{element.paymentId}</td>
                            <td>{element.editorName}</td>
                            <td><td>{moment(element.paymentDate).format("DD MMMM YYYY")}</td></td>
                            <td>{element.paymentAmount}₺</td>
                            <td>{element.payerName}</td>
                        </tr>
                    ))}

                    </tbody>
                </Table>
            </div>
            <Pagination>
                {Array.from({length: response.pageCount}, (item, index) =>
                    <Pagination.Item key={index} onClick={(page) => setPage(index + 1)}
                                     active={response.page === index}>{(index + 1)}</Pagination.Item>
                )}
            </Pagination>

        </>
    )

}

export default memo(DataTable);
